import { Pipe, PipeTransform } from '@angular/core';
import { MetadataService } from '../../../../../services/metadata.service';
import { Observable } from 'rxjs';
import { TableType } from '../../../../../models/shipment';

@Pipe({
  name: 'columnNameByKey',
  standalone: true
})
export class ColumnNameByKeyPipe implements PipeTransform {
  constructor(private metadataService: MetadataService) {}

  transform(key: string, type: TableType): Observable<string> {
    return this.metadataService.getColumnNameBy(key, type);
  }
}
